import SpsPasswordInput from "./SpsPasswordInput";

export default SpsPasswordInput;

export { SpsPasswordInput };
